module.exports = __webpack_public_path__ + "1f579bb3a37b649fdfcc48e20b7d5686.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/favorite/my-nghe.jpg
// module id = ./assets/images/favorite/my-nghe.jpg
// module chunks = 0